module.exports = __webpack_public_path__ + "img/setting_25.25e9683f.svg";